/**
 * Footer async.
 */
(() => {
    /**
     * For some reason htmx:afterSettle runs twice. Preventing it with this flag.
     */
    let done = false;

    document
        .querySelector('.js-site-footer')
        ?.addEventListener('htmx:afterSettle', (e) => {
            if (done) {
                return;
            }

            let footer = document.querySelector('.js-site-footer-content');

            if (!footer) {
                return;
            }

            H_Tools?.links?.addAriaCurrent(footer);
            H_Tools?.links?.modifyLinks(footer);

            done = true;
        });
})();
